import { DirectionMarkerSidebar } from 'components/minute/sidebar/MarkerSidebar/DirectionMarkerSidebar';
import { IconExternalPointSidebar } from 'components/minute/sidebar/MarkerSidebar/IconExternalPointSidebar copy';
import { IconMarkerSidebar } from 'components/minute/sidebar/MarkerSidebar/IconMarkerSidebar';
import { ImageMarkerSidebar } from 'components/minute/sidebar/MarkerSidebar/ImageMarkerSidebar';
import { IndoorStandMarkerSidebar } from 'components/minute/sidebar/MarkerSidebar/IndoorStandMarkerSidebar';
import { LineMarkerSidebar } from 'components/minute/sidebar/MarkerSidebar/LineMarkerSidebar';
import { PolygonMarkerSidebar } from 'components/minute/sidebar/MarkerSidebar/PolygonMarkerSidebar';
import { RouteMarkerSidebar } from 'components/minute/sidebar/MarkerSidebar/RouteMarkerSidebar';
import { TextMarkerSidebar } from 'components/minute/sidebar/MarkerSidebar/TextMarkerSidebar';
import { VariantIconExternalPointSidebar } from 'components/minute/sidebar/MarkerSidebar/VariantIconExternalPointSidebar';
import { VariantIconMarkerSidebar } from 'components/minute/sidebar/MarkerSidebar/VariantIconMarkerSidebar';
import { WallMarkerSidebar } from 'components/minute/sidebar/MarkerSidebar/WallMarkerSidebar';
import { InteractivitySidebar } from 'components/minute/sidebar/interactivity/InteractivitySidebar';
import { OptionRowValue } from 'elements/minute/sidebar/sidebarComponents/atomic/OptionRowValue';
import { motion } from 'framer-motion';
import { ANIMATION_APPEAR } from 'libs/styles/animations';
import { useContext } from 'react';
import { IWorldMarker } from 'react-give-me-map';
import { CtxEdit } from 'session/ctxEdit';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    marker: IWorldMarker;
    className?: string;
}

export const MarkerSidebar = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);
    const marker = props.marker;

    return (
        <S_MarkerSidebar className={props.className}>
            <S_Wrap>
                <S_OptionRowValue
                    items={[
                        { text: Localization.PROPERTIES, iconName: 'wrench' },
                        { text: Localization.INTERACTIVITY, iconName: 'bullseye-pointer' }
                    ]}
                    selectedIndex={ctxEdit.markerSidebar === 'properties' ? 0 : 1}
                    onSelected={(newIndex) => {
                        if (newIndex === 0) {
                            ctxEdit.setMarkerSidebar('properties');
                        } else {
                            ctxEdit.setMarkerSidebar('interactivity');
                        }
                    }}
                />
            </S_Wrap>
            {ctxEdit.markerSidebar === 'interactivity' && <InteractivitySidebar />}
            {ctxEdit.markerSidebar === 'properties' && (
                <>
                    {marker.elementType === 'v2/text' && (
                        <motion.div {...ANIMATION_APPEAR}>
                            <TextMarkerSidebar key={marker.id} marker={marker} />
                        </motion.div>
                    )}
                    {marker.elementType === 'v2/route' && (
                        <motion.div {...ANIMATION_APPEAR}>
                            <RouteMarkerSidebar key={marker.id} marker={marker} />
                        </motion.div>
                    )}
                    {marker.elementType === 'direction' && (
                        <motion.div {...ANIMATION_APPEAR}>
                            <DirectionMarkerSidebar key={marker.id} marker={marker} />
                        </motion.div>
                    )}
                    {marker.elementType === 'v2/line' && (
                        <motion.div {...ANIMATION_APPEAR}>
                            <LineMarkerSidebar key={marker.id} marker={marker} />
                        </motion.div>
                    )}
                    {marker.elementType === 'v2/polygon' && (
                        <motion.div {...ANIMATION_APPEAR}>
                            <PolygonMarkerSidebar key={marker.id} marker={marker} />
                        </motion.div>
                    )}
                    {marker.elementType === 'v2/variant_icon' && marker.isExternalPoint && (
                        <motion.div {...ANIMATION_APPEAR}>
                            <VariantIconExternalPointSidebar key={marker.id} marker={marker} />
                        </motion.div>
                    )}
                    {marker.elementType === 'v2/variant_icon' && !marker.isExternalPoint && (
                        <motion.div {...ANIMATION_APPEAR}>
                            <VariantIconMarkerSidebar key={marker.id} marker={marker} />
                        </motion.div>
                    )}
                    {marker.elementType === 'v2/icon' && marker.isExternalPoint && (
                        <motion.div {...ANIMATION_APPEAR}>
                            <IconExternalPointSidebar key={marker.id} marker={marker} />
                        </motion.div>
                    )}
                    {marker.elementType === 'v2/icon' && !marker.isExternalPoint && (
                        <motion.div {...ANIMATION_APPEAR}>
                            <IconMarkerSidebar key={marker.id} marker={marker} />
                        </motion.div>
                    )}
                    {marker.elementType === 'v2/image' && (
                        <motion.div {...ANIMATION_APPEAR}>
                            <ImageMarkerSidebar key={marker.id} marker={marker} />
                        </motion.div>
                    )}
                    {marker.elementType === 'v2/wall' && (
                        <motion.div {...ANIMATION_APPEAR}>
                            <WallMarkerSidebar key={marker.id} marker={marker} />
                        </motion.div>
                    )}
                    {marker.elementType === 'indoor_stand' && (
                        <motion.div {...ANIMATION_APPEAR}>
                            <IndoorStandMarkerSidebar key={marker.id} marker={marker} />
                        </motion.div>
                    )}
                    <S_ID>ID: {marker.id}</S_ID>
                </>
            )}
        </S_MarkerSidebar>
    );
};

const S_MarkerSidebar = styled.div`
    width: 100%;
    padding: 0 0 200px 0;
`;

const S_Wrap = styled.div`
    padding: 15px;
`;

const S_OptionRowValue = styled(OptionRowValue)``;

const S_ID = styled.div`
    padding: 15px;
    font-size: 12px;
    color: #999;
`;
